import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../api';
import { createSafeHtml } from '../../utils/sanitize';
import DashboardLayout from '../../Components/Dashboard/DashboardLayout';

const LearningPage = () => {
  const { courseId } = useParams();
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    load();
  }, [courseId]);

  const load = async () => {
    const res = await api.get(`/learning/courses/${courseId}`);
    setPayload(res.data);
  };

  const allLessons = useMemo(
    () =>
      payload?.course?.modules?.flatMap(module =>
        (module.lessons || []).map(lesson => ({ ...lesson, moduleTitle: module.title }))
      ) || [],
    [payload]
  );

  const completed = new Set(payload?.completed_lesson_ids || []);

  const markComplete = async lessonId => {
    await api.post(`/learning/courses/${courseId}/lessons/${lessonId}/complete`);
    toast.success('Progress updated');
    load();
  };

  if (!payload) return <DashboardLayout>Loading...</DashboardLayout>;

  return (
    <DashboardLayout>
      <div className="container py-4">
        <h3>{payload.course.title}</h3>
        <div dangerouslySetInnerHTML={createSafeHtml(payload.course.description || '')} />

        <div className="list-group">
          {allLessons.map(lesson => (
            <div key={lesson.id} className="list-group-item">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="fw-bold">{lesson.title}</div>
                  <small>
                    {lesson.moduleTitle} - {lesson.lesson_type}
                  </small>
                </div>
                <div className="d-flex gap-2">
                  {lesson.resource_url && (
                    <a href={lesson.resource_url} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-secondary">
                      Open
                    </a>
                  )}
                  <button
                    className="btn btn-sm btn-success"
                    disabled={completed.has(lesson.id)}
                    onClick={() => markComplete(lesson.id)}
                  >
                    {completed.has(lesson.id) ? 'Completed' : 'Mark complete'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default LearningPage;
